export const KycProps = {
  ACCOUNT: 'account',
  AT_CUSTOMER_ID: 'atCustomerId',
  BENEFICIARY_NAME: 'beneficiaryName',
  BENEFICIARY_RELATIONSHIP: 'beneficiaryRelationship',
  BIRTH_DATE: 'birthDate',
  BIRTH_PLACE: 'birthPlace',
  CITIZENSHIP: 'citizenship',
  EDUCATION_BACKGROUND: 'educationBackground',
  EMAIL: 'email',
  BANK: 'bankId',
  BANK_BRANCH_NAME: 'branchName',
  BANK_BRANCH_ID: 'branchId',
  EMPLOYMENT_STATUS: 'employementStatus',
  EMPLOYER_NAME: 'employerName',
  EMPLOYMENT_DATE: 'employmentDate',
  FIRSTNAME: 'firstName',
  GENDER: 'gender',
  GOV_RELATIVE: 'govRelative',
  GOV_RELATIVE_DETAIL: 'govRelativeDetail',
  ADDRESS_HOME: 'homeAddress',
  CITY_HOME: 'homeCity',
  COUNTRY_HOME: 'homeCountry',
  FAX_HOME: 'homeFaxNumber',
  PERIOD_HOME: 'homeInhabitPeriod',
  PHONE_HOME: 'homePhoneNumber',
  POSTAL_HOME: 'homePostalCode',
  PROVINCE_HOME: 'homeProvince',
  ID_EXPIRY: 'idExpirationDate',
  ID_NUMBER: 'idNumber',
  ID_TYPE: 'idType',
  INVEST_ALLOCATION: 'investAllocation',
  INVEST_INTEREST: 'investInterest',
  INVEST_REGULAR: 'investRegular',
  INVEST_PURPOSE: 'investmentPurpose',
  JOB_TITLE: 'jobTitle',
  LAST_NAME: 'lastName',
  ADDRESS: 'legalAddress',
  CITY: 'legalCity',
  COUNTRY: 'legalCountry',
  FAX: 'legalFaxNumber',
  LEGAL_PHONE_NUMBER: 'legalPhoneNumber',
  PHONE_NUMBER: 'phoneNumber',
  POSTAL_CODE: 'legalPostalCode',
  PROVINCE: 'legalProvince',
  CIVIL_STATUS: 'maritalStatus',
  MIDDLE_NAME: 'middleName',
  MOBILE_NUMBER: 'mobileNumber',
  MOTHER_MAIDEN_NAME: 'motherMaidenName',
  NATIONALITY: 'nationality',
  NATURE_BUSINESS: 'natureOfBusiness',
  NETWORTH: 'netWorth',
  OCCUPATION: 'occupation',
  ADDRESS_OFFICE: 'officeAddress',
  CITY_OFFICE: 'officeCity',
  COUNTRY_OFFICE: 'officeCountry',
  FAX_OFFICE: 'officeFaxNumber',
  PHONE_OFFICE: 'officePhoneNumber',
  POSTAL_OFFICE: 'officePostalCode',
  PROVINCE_OFFICE: 'officeProvince',
  PORTALCIF: 'portalcif',
  MAILING_ADDRESS: 'preferredMailingAddress',
  PREV_HOME: 'prevHome',
  PROFESSION: 'profession',
  QUESTION: 'question',
  REFERRAL: 'referral',
  REFERRAL_NAME: 'referralName',
  RELIGION: 'religion',
  RISKPROFILE: 'riskProfile',
  SALES: 'sales',
  SALUTAION: 'salutation',
  SHAREHOLDER: 'shareholder',
  SHAREHOLDER_LIST: 'shareholder_list',
  SSS: 'socialSecurity',
  SOURCE_OF_INCOME: 'sourceOfIncome',
  BIRTH_DATE_SPOUSE: 'spouseDateOfBirth',
  SPOUSE_NAME: 'spouseName',
  STATUS: 'status',
  TAX_ID: 'taxId',
  TAX_NUMBER: 'taxNo',
  TOTAL_CHILDREN: 'totalChildren',
  ANNUAL_INCOME: 'totalIncomePa',
  WORK_GOV: 'workGov',
  WORK_GOV_DETAIL: 'workGovDetail',
  //not found in schema
  AGE: 'age',
  DOCTYPE_1: 'DocTyp01',
  DOCTYPE_3: 'DocTyp03',
  ACCOUNT_NUMBER: 'settlementAccountNo',
  ACCOUNT_NAME: 'settlementAccountName',
  ACCOUNT_TYPE: 'typeOfAccount',
  SETTLEMENT_ACCOUNT_ID: 'settlementAccountId',
  IS_SAME_ADDRESS: 'sameAddress',
};
